export default __webpack_public_path__ + "logo-2x.62adc03ced6dda64eb82b3e1302f4507.png";